<template>
  <v-container class="py-0">
    <v-row>
      <v-col cols="12" class="columnPadding">
        <h4 v-if="formElements.length > 0 || noDateFilter == false" class="font-weight-light">{{getTranslation('Filters:','filters')}}</h4>
        <FormBuilder
          @formSubmit="callApiEndpoint"
          :formElements="allowedFormElements"
          :errors="errors"
          :useCancel="false"
          :loading="showLoader"
          :submit="submitButton"
          :key="incrementKey"
          :incommingObject="incommingObject"
        >
          <v-col cols="12" v-if="!noDateFilter">
            <DateTimePickerFilter
              :error="dateErrors"
              :blockedIntervals="blockedIntervals"
              :monthPeriodInterval="monthPeriodInterval"
              v-model="dateObject"
            ></DateTimePickerFilter>
          </v-col>
        </FormBuilder>
      </v-col>
    </v-row>
    <v-snackbar color="orange" dark v-model="snackbar">
      <v-card-text> {{ serverMessage }} </v-card-text>
    </v-snackbar>
  </v-container>
</template>
<script>
import httpClient from '../../api/httpClient'
import DateTimePickerFilter from '@/components/v2/DateTimePickerFilter'
import translate from '@/utils/genTable/multilanguageHelper.js'
import { mapState } from 'vuex'
import { useCaseMap } from '@/utils/useCase/useCaseMap'
export default {
  props: {
    blockedIntervals: Array,
    noDateFilter: Boolean,
    formElements: {
      type: Array,
      required: true
    },
    incommingObject: Object,
    endPoint: String,
    monthPeriodInterval:{
      type: Number,
      default:0
    },
    alreadyExistingSearchObject: null,
    method: {
      type: String,
      default: 'get'
    }
  },
  components: {
    TimeFilter: () => import('@/components/v2/TimeFilterV2'),
    DateTimePickerFilter
  },
  data() {
    return {
      showLoader: false,
      serverMessage: '',
      snackbar: false,
      dateObject: {
        startDate: new Date().toISOString().substr(0, 10),
        endDate: new Date().toISOString().substr(0, 10)
      },
      dateErrors: '',
      errors: {},
      submitButton: {
        text: '$search',
        color: 'primary'
      },
      incrementKey: 0
    }
  },
  methods: {
    getTranslation(toTranslate, root) {
      return translate(toTranslate, root)
    },
    callApiEndpoint(data) {
      this.showLoader = true
      this.$emit('dataProvided', data)

      const bodyMethods = ['post', 'put', 'patch']
      const usesBody = bodyMethods.includes(this.method)

      let request
      if (usesBody) {
        const body = {}
        for (const key in data) {
          const val = data[key]
          if (val && val.__type === 'selectAll') {
            body[val.backendKey] = true
          } else {
            body[key] = val
          }
        }
        Object.assign(body, this.dateObject)
        if (this.alreadyExistingSearchObject != null) {
          Object.assign(body, this.alreadyExistingSearchObject)
        }
        request = httpClient[this.method](this.endPoint, body)
      } else {
        let queryString = this.endPoint + '?'
        for (let singleData in data) {
          if (Array.isArray(data[singleData])) {
            for (let singleProp of data[singleData])
              queryString += singleData + '=' + singleProp + '&'
          } else {
            queryString += singleData + '=' + data[singleData] + '&'
          }
        }
        let objectKeys = Object.keys(this.dateObject)
        for (let singleDate in objectKeys) {
          queryString +=
            objectKeys[singleDate] +
            '=' +
            this.dateObject[objectKeys[singleDate]] +
            '&'
        }
        if (this.alreadyExistingSearchObject != null) {
          let alreadyExistingKeys = Object.keys(this.alreadyExistingSearchObject)
          alreadyExistingKeys.forEach(element => {
            queryString +=
              element + '=' + this.alreadyExistingSearchObject[element] + '&'
          })
        }
        request = httpClient[this.method](queryString)
      }

      request
        .then(response => {
          if (response.data.length == 0) {
            this.serverMessage = translate('nodata', 'errors', true)
            this.snackbar = true
            setTimeout(function() {
              this.snackbar = false
            }, 2500)
          }
          if (response.data.reportIsScheduled) {
            this.serverMessage = translate('reportQueued', 'errors', true)
            this.snackbar = true
            setTimeout(function() {
              this.snackbar = false
            }, 2500)
          }
          response.data.choosenDates = this.dateObject
          this.$emit('apiResponded', response.data)
          let errors = ''
          this.dateErrors = errors
          this.showLoader = false
        })
        .catch(error => {
          if (error.response.status == 422) {
            let dateerrors = ''
            let errors = {}
            let additionalExternalErrors = []
            for (var validationError of error.response.data.errors) {
              for (var formElementKey of this.formElements) {
                if (
                  validationError.propertyName != formElementKey.key &&
                  validationError.propertyName != 'Groups'
                ) {
                  additionalExternalErrors.push(validationError)
                  break
                }
              }
              if (validationError.PropertyName == 'StartDate') {
                dateerrors = validationError.Error
              } else if (validationError.PropertyName == 'EndDate') {
                dateerrors = validationError.Error
              } else {
                let errorArray = []
                errorArray.push(validationError.Error)
                errors[validationError.PropertyName] = errorArray
              }
            }
            if (additionalExternalErrors.length > 0) {
              this.$emit('externalErrorsHappend', additionalExternalErrors)
            }
            this.dateErrors = dateerrors
            this.errors = errors
          } else if (error.response.status == 503) {
            this.serverMessage =
              'Server is unavailable at the moment, please try later'
            this.snackbar = true
            setTimeout(function() {
              this.snackbar = false
            }, 2500)
          } else {
            this.serverMessage = 'Server error'
            this.snackbar = true
            setTimeout(function() {
              this.snackbar = false
            }, 2500)
          }
          this.$emit('errorOccured', error)
          this.showLoader = false
        })
    },
    handleSearchDateObjectChange(data) {
      this.dateObject[data.key] = data.value
    }
  },
  computed: {
    ...mapState('user', ['userDecoded']),
    allowedFormElements() {
      let allowedUseCases = JSON.parse(this.userDecoded.UserData)
        .AllowedUseCaseIds
      return this.formElements.filter(element => !element.hasOwnProperty("useCaseName") || allowedUseCases.includes(useCaseMap[element.useCaseName]))
    }
  },
  watch: {
    formElements: {
      handler() {
        this.incrementKey++
      }
    }
  }
}
</script>
<style scoped>
#reportFilters > .container {
  padding-top: 0px;
  padding-bottom: 0px;
}

#reportFilters > .container > .row > .col {
  padding: 8px;
}
.columnPadding {
  padding: 8px 8px;
}
</style>
